import Enum from './Enum';

class PlanetInvoiceNumberType extends Enum {
    Receipt = {
        value: 'receipt',
        label: 'Receipt Number (default)',
    };
    OrderNumber = {
        value: 'order_number',
        label: 'Order Number',
    };
    Custom = {
        value: 'custom',
        label: 'Custom (Advanced)',
    };
}

export default new PlanetInvoiceNumberType();
